import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import Audio from "../Audio/Audio"
import Video from "../Video/Video"
import Image from "../Image/Image"
import File from "../File/File"
import Text from "../Text/Text"
import Contacts from "../Contacts/Contacts"

import "./Misc.scss"

function locationTemplate(data, i) {
  const { title, url } = data
  if (url) {
    return (
      <a key={i} className="message-bubble location" href={url} target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon
          className="icon"
          icon="map-marker"
        />
        <span>{title}</span>
      </a>
    )
  }
  return (
    <div key={i} className="message-bubble location">
      <FontAwesomeIcon
        className="icon"
        icon="map-marker"
      />
      <span>{title}</span>
    </div>
  )
}

const Misc = ({ data, isUser = false, color }) => {
  const { attachments } = data
  return attachments.map((attachment, i) => {
    if (attachment) {
      switch (attachment.type) {
        case "IMAGE": return (<Image key={i} data={attachment} isUser={isUser} color={color} />)
        case "TEAMWORK_VOICE":
        case "AUDIO":
          return (<Audio key={i} data={attachment} isUser={isUser} color={color} />)
        case "VIDEO": return (<Video key={i} data={attachment} isUser={isUser} color={color} />)
        case "FILE":
          return (<File key={i} data={attachment} isUser={isUser} color={color} />)
        case "LOCATION":
          return locationTemplate(attachment, i)
        case "CONTACTS":
          return (<Contacts key={i} data={attachment} isUser={isUser} color={color} />)
        default:
          return <Text data={{ text: "Message could not be displayed" }} isUser={isUser} color={color} />
      }
    } else {
      return <Text data={{ text: "Message could not be displayed" }} isUser={isUser} color={color} />
    }
  })
}

export default Misc
